module.exports = __webpack_public_path__ + "static/media/KW12_tvar_vystuz.94dd845d.png";